import Button from '@mui/material/Button';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Badge } from '@mui/material';
import { NAVIGATE } from '../constants';

interface NavigationItemsProps {
	isMobile: boolean;
	handleCloseNavMenu: () => void;
	location: ReturnType<typeof useLocation>;
	navigate: ReturnType<typeof useNavigate>;
}

export const NavigationItems: FC<NavigationItemsProps> = ({
	isMobile,
	handleCloseNavMenu,
	location,
	navigate,
}) => {
	return (
		<>
			{NAVIGATE.map((item) => {
				const { name } = item;
				const { path } = item;

				const isActive =
					location.pathname.split('/')[1] === path.split('/')[1] ||
					location.pathname.split('/')[1] === path.split('/')[1].slice(0, -1);

				if (name === 'New Item') {
					return (
						<Badge
							key={path}
							badgeContent="New"
							color="error"
							sx={{
								'& .MuiBadge-badge': {
									top: '6px',
									right: '4px',
									padding: '2px 5px',
									height: 'auto',
									fontSize: '0.65rem',
									fontWeight: 600,
								},
							}}
						>
							<Button
								onClick={() => {
									navigate(path);
									if (isMobile) handleCloseNavMenu();
								}}
								sx={{
									color: isActive ? '#5aa1bf' : 'primary',
									display: 'block',
									textTransform: 'none',
									fontWeight: 600,
								}}
							>
								{name}
							</Button>
						</Badge>
					);
				}

				return (
					<Button
						key={path}
						onClick={() => {
							navigate(path);
							if (isMobile) handleCloseNavMenu();
						}}
						sx={{
							color: isActive ? '#5aa1bf' : 'primary',
							display: 'block',
							textTransform: 'none',
							fontWeight: 600,
						}}
					>
						{name}
					</Button>
				);
			})}
		</>
	);
};
